import React from 'react';

const CheckIcon = ({ width = 15, height = 11, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 15 11'
      fill='none'
      {...props}
    >
      <path
        d='M13.732.296a1 1 0 0 0-1.42 0l-7.45 7.46-3.13-3.14a1.022 1.022 0 1 0-1.42 1.47l3.84 3.84a1 1 0 0 0 1.42 0l8.16-8.16a1 1 0 0 0 0-1.47'
        fill='currentColor'
      />
    </svg>
  );
};

export default CheckIcon;
